document.addEventListener('keydown', (e) => {
  if (!(e.key === 'Enter' && (e.ctrlKey || e.metaKey))) {
    return
  }
  const form = e.target.form
  if (!form) { return }
  e.preventDefault()
  form.requestSubmit()
})
